import template from './netverify.html';
class VerificationNetverifyController {
    constructor($state, $stateParams, GmwNetVerify) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.GmwNetVerify = GmwNetVerify;
        this.$onInit = () => {
            this.start();
        };
        this.$onDestroy = () => {
            this.GmwNetVerify.tearDown();
        };
        this.start = () => {
            this.GmwNetVerify.init(this.$stateParams.code)
                .then(({ url, promise }) => {
                this.iframeSrc = url;
                promise.then(() => {
                    this.$state.go('holding.dashboard.overview', {}, { reload: true });
                })
                    .catch((errorCode) => {
                    this.error = errorCode;
                });
            });
        };
        this.retry = () => {
            this.error = undefined;
            this.start();
        };
    }
}
VerificationNetverifyController.$inject = ['$state', '$stateParams', 'GmwNetVerify'];
const Eid = {
    controller: VerificationNetverifyController,
    template,
};
const componentName = 'gmwVerificationNetverify';
angular.module('app.holding.dashboard.onboarding').component(componentName, Eid);
export default componentName;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/verification/controllers/netverify/netverify.ts